import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { toast } from 'react-hot-toast';

const DeleteGroupDialog = ({ open, onClose, onSuccess, group, changeGroupStatus }) => {
  const [working, setWorking] = useState(false);

  const handleConfirm = async () => {
    if (!group?.id) return;
    setWorking(true);
    try {
      await changeGroupStatus(group.id, 'DELETED');
      toast.success('Group marked as deleted');
      onSuccess?.();
      onClose();
    } catch (error) {
      const err =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        'Failed to update group';
      toast.error(typeof err === 'string' ? err : 'Failed to update group');
    } finally {
      setWorking(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => !working && onClose()} maxWidth="sm" fullWidth>
      <DialogTitle>Delete group?</DialogTitle>
      <DialogContent>
        <Typography variant="body2">Do you want to delete the group?</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={working}>
          Cancel
        </Button>
        <Button color="error" variant="contained" onClick={handleConfirm} disabled={working}>
          {working ? 'Deleting…' : 'Confirm'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteGroupDialog;
